import React from 'react';
import Image from 'next/image';
import SmallScreen from '@/components/Device/SmallScreen';
import MediumScreen from '@/components/Device/MediumScreen';
import MaxScreen from '@/components/Device/MaxScreen';
import { useTranslation } from 'next-i18next';

const Countries = () => {
  const { t } = useTranslation(['whyWukong']);

  return (
    <ul className="mt-[5px] flex flex-wrap justify-center lg:mt-[26px] xl:mt-[40px]">
      {Array(8)
        .fill(0)
        .map((_, index) => {
          const country = `https://cdnwukong.com/images/growth/official/country_${index + 1}.svg`;
          return (
            <section key={index}>
              <SmallScreen>
                <li
                  key={country}
                  className="mx-[10px] mt-[20px] h-[30px] w-[40px] overflow-hidden rounded-[2.5px] border-[1px] border-solid border-[rgba(0,0,0,0.10)] shadow-[0px_3.75px_5.625px_0px_rgba(0,0,0,0.10)]"
                >
                  <Image src={country} layout="responsive" height={30} width={40} alt={t('悟空学生覆盖国家')} />
                </li>
              </SmallScreen>
              <MediumScreen>
                <li
                  key={country}
                  className="mx-[12px] h-[36px] w-[48px] overflow-hidden rounded-[3px] border-[1px] border-solid border-[rgba(0,0,0,0.10)] shadow-[0px_3.75px_5.625px_0px_rgba(0,0,0,0.10)]"
                >
                  <Image src={country} layout="responsive" height={36} width={48} alt={t('悟空学生覆盖国家')} />
                </li>
              </MediumScreen>
              <MaxScreen>
                <li
                  key={country}
                  className="mx-[20px] h-[45px] w-[60px] overflow-hidden rounded-[3.75px] border-[1px] border-solid border-[rgba(0,0,0,0.10)] shadow-[0px_3.75px_5.625px_0px_rgba(0,0,0,0.10)]"
                >
                  <Image src={country} layout="responsive" height={45} width={60} alt={t('悟空学生覆盖国家')} />
                </li>
              </MaxScreen>
            </section>
          );
        })}
    </ul>
  );
};

export default Countries;
